/**
 * Constants for Dropdown component
 */

const INPUT_MIN_WIDTH = '464px'

export default INPUT_MIN_WIDTH
